import { Component, Input } from '@angular/core';
import { severityColorMap, SeverityTypes } from 'src/app/model/global-interface';

@Component({
  selector: 'app-form-message',
  imports: [],
  templateUrl: './form-message.component.html',
  styleUrl: './form-message.component.scss'
})
export class FormMessageComponent {
  
  @Input() content: string = '';
  @Input() severity: SeverityTypes = SeverityTypes.warning;
  severityColorMap = severityColorMap;


}
